import {first} from "lodash";

const useValidationHandler = (exception: any, form: any): void => {
    if (exception?.response?.status === 422) {
        form.errors = exception?.response?.data?.errors;
    }
}

const useValidation = (field: any, bag: any): string | null | undefined => {
    if (typeof field === 'string' && field.includes(',')) {
        const fields = field.split(',');
        for (const fieldItem of fields) {
            if (typeof bag === 'object' && bag !== null && bag.hasOwnProperty(fieldItem)) {
                return first(bag[fieldItem]);
            }
        }
    } else {
        if (typeof bag === 'object' && bag !== null && bag.hasOwnProperty(field)) {
            return first(bag[field]);
        }
    }

    return null;
};

const toggleInvalidClass = (el: Element, binding: any) => {
    const error = useValidation(binding.value, binding.arg);
    const hasInvalidClass = el.classList.contains('is-invalid');

    if (error !== null && !hasInvalidClass) {
        el.classList.add('v-input--error');
        el.classList.add('v-field--error');
    } else if (error === null && hasInvalidClass) {
        el.classList.remove('v-input--error');
        el.classList.remove('v-field--error');
    }
}

export default {
    install: (app: any) => {
        app.directive('validate', {
            mounted(el: Element, binding: object) {
                toggleInvalidClass(el, binding);
            },
            updated(el: Element, binding: object) {
                toggleInvalidClass(el, binding);
            }
        });
    }
}

export {
    useValidationHandler,
    useValidation
}
